import { Adjacent } from '@/axios/api'

const nearbyScenic = {
  state: {
    nearbyScenic: []
  },
  mutations: {
    SET_NEARBYSCENIC (state, nearbyScenic) {
      state.nearbyScenic = nearbyScenic
    }
  },
  actions: {
    NEARBYSCENIC ({ commit }, params) {
      Adjacent(params).then(res => {
        this.state.nearbyScenic = res.data.data
      })
    }
  }
}

export default nearbyScenic



// WEBPACK FOOTER //
// ./src/store/modules/getNearbyScenic.js